<div class="titre-details-container p-4">
  <form [formGroup]="formGroup">
    <div class="grid">
      <div class="col-12">
        <div class="field">
          <label for="isin" class="block mb-2">Code ISIN</label>
          <input
            id="isin"
            pInputText
            formControlName="isin"
            placeholder="Ex: XS1234567890"
            class="w-full" />
        </div>
      </div>

      <div class="col-12">
        <div class="field">
          <label for="typeInstrument" class="block mb-2">Type d'instrument *</label>
          <p-select
            id="typeInstrument"
            formControlName="typeInstrument"
            [options]="instrumentTypes"
            optionLabel="label"
            optionValue="value"
            placeholder="Sélectionner un type"
            [style]="{ width: '100%' }">
          </p-select>
          <small class="p-error" *ngIf="formGroup.get('typeInstrument')?.invalid && formGroup.get('typeInstrument')?.touched">
            Le type d'instrument est obligatoire
          </small>
        </div>
      </div>

      <div class="col-12">
        <div class="field">
          <label for="dueDate" class="block mb-2">Date d'échéance *</label>
          <p-datepicker
            id="dueDate"
            formControlName="dueDate"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [style]="{ width: '100%' }">
          </p-datepicker>
          <small class="p-error" *ngIf="formGroup.get('dueDate')?.invalid && formGroup.get('dueDate')?.touched">
            La date d'échéance est obligatoire
          </small>
        </div>
      </div>

      <div class="col-12">
        <div class="field">
          <label for="rate" class="block mb-2">Taux d'intérêt (%) *</label>
          <p-inputNumber
            id="rate"
            formControlName="rate"
            mode="decimal"
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            suffix="%"
            [style]="{ width: '100%' }">
          </p-inputNumber>
          <small class="p-error" *ngIf="formGroup.get('rate')?.invalid && formGroup.get('rate')?.touched">
            Le taux est obligatoire
          </small>
        </div>
      </div>

      <div class="col-12">
        <div class="field">
          <label for="unitNominalValue" class="block mb-2">Valeur nominale unitaire *</label>
          <p-inputNumber
            id="unitNominalValue"
            formControlName="unitNominalValue"
            mode="currency"
            currency="XOF"
            locale="fr-FR"
            [style]="{ width: '100%' }">
          </p-inputNumber>
          <small class="p-error" *ngIf="formGroup.get('unitNominalValue')?.invalid && formGroup.get('unitNominalValue')?.touched">
            La valeur nominale est obligatoire
          </small>
        </div>
      </div>
    </div>

    <!-- Boutons d'action -->
    <div class="flex justify-content-end gap-2 mt-4">
      <p-button
        label="Fermer"
        icon="pi pi-times"
        (onClick)="cancel()"
        [severity]="isView ? 'primary' : 'secondary'"
        [outlined]="!isView">
      </p-button>
      <p-button
        *ngIf="!isView"
        [label]="boundData?.isEdit ? 'Modifier' : 'Ajouter'"
        icon="pi pi-check"
        (onClick)="save()"
        severity="primary">
      </p-button>
    </div>
  </form>
</div>
